const slides = document.querySelectorAll('.carouselItem');

if (slides && slides.length > 0) {
	let index = 0;
	const next = document.querySelector("[data-control='next']");
	const prev = document.querySelector("[data-control='prev']");

	next.addEventListener('click', function () {
		if (index !== slides.length - 1) {
			slides[index].classList.add('moveSlide');
			index += 1;
		}
	});

	prev.addEventListener('click', function () {
		if (index !== 0) {
			slides[index - 1].classList.remove('moveSlide');
			index -= 1;
		}
	});
}

//TODO: remove this when we update merch tool
document.addEventListener('DOMContentLoaded', () => {
	const countdown = document.querySelector('.countdown-container');
	const carouselContainer = document.querySelector('.carouselContainer ');

	if (countdown && carouselContainer ) {
		carouselContainer.classList.add('countdown-active');
		carouselContainer.classList.add('mb-4');
	}
});
